const API = process.env.REACT_APP_BACKEND_URL;

// Local paths ("/images/x.jpg") and full URLs pass through; storage paths go via the backend.
export const mediaUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("/") || src.startsWith("http")) return src;
  return `${API}/api/files/${src}`;
};
